import { useCallback, useState } from 'react';

/** Preferências de exibição guardadas no navegador (idioma e fuso). A interface segue em pt-BR. */
export const LANGUAGES: Array<[string, string]> = [['pt-BR', 'Português (Brasil)']];

export const TIMEZONES: Array<[string, string]> = [
  ['America/Sao_Paulo', 'Brasília (GMT-3)'],
  ['America/Manaus', 'Manaus (GMT-4)'],
  ['America/Rio_Branco', 'Rio Branco (GMT-5)'],
  ['America/Noronha', 'Fernando de Noronha (GMT-2)'],
  ['UTC', 'UTC'],
];

export function readPreference(key: string, fallback: string): string {
  try { return localStorage.getItem(`ingrave-${key}`) || fallback; } catch { return fallback; }
}

export function usePreference(key: string, fallback: string): [string, (v: string) => void] {
  const [value, setValue] = useState(() => readPreference(key, fallback));
  const set = useCallback((v: string) => {
    setValue(v);
    try { localStorage.setItem(`ingrave-${key}`, v); } catch { /* sem storage */ }
  }, [key]);
  return [value, set];
}
